import React, { useState, useEffect } from 'react';
import api from '../services/api';
import {
    Box, Grid, Paper, TextField, Typography, Button, List, ListItem, ListItemText, Divider
} from '@mui/material';

const POS = () => {
    const [search, setSearch] = useState('');
    const [cart, setCart] = useState([]);
    const [products, setProducts] = useState([]);

    const searchProducts = async () => {
        if (search.length > 2) {
            const res = await api.get(`/inventory?search=${search}`);
            if (res.data.success) setProducts(res.data.data);
        }
    };

    const addToCart = (product) => {
        setCart([...cart, { ...product, quantity: 1, total: product.sale_price }]);
        setProducts([]);
        setSearch('');
    };

    const handleCheckout = async () => {
        const total = cart.reduce((sum, item) => sum + Number(item.total), 0);
        const payload = {
            store_id: 1,
            total: total,
            subtotal: total, // Simplified tax logic
            items: cart.map(item => ({
                inventory_id: item.id,
                inventory_imei_id: null,
                quantity: item.quantity,
                unit_price: item.sale_price,
                discount: 0,
                total: item.total
            })),
            payment_method: 'cash',
            customer_id: null,
            notes: ''
        };

        try {
            const res = await api.post('/pos', payload);
            if (res.data.success) {
                alert('Venta Exitosa: ' + res.data.invoice);
                setCart([]);
            }
        } catch (e) {
            alert('Error en venta');
        }
    };

    const total = cart.reduce((sum, item) => sum + Number(item.total), 0);

    return (
        <Grid container spacing={2}>
            <Grid item xs={8}>
                <Paper sx={{ p: 2, height: '100%' }}>
                    <Typography variant="h6">Productos</Typography>
                    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                        <TextField
                            fullWidth
                            label="Buscar Producto..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyUp={(e) => e.key === 'Enter' && searchProducts()}
                        />
                        <Button variant="contained" onClick={searchProducts}>Buscar</Button>
                    </Box>
                    <List>
                        {products.map(p => (
                            <ListItem key={p.id} button onClick={() => addToCart(p)}>
                                <ListItemText primary={p.name} secondary={`$${p.sale_price} - Stock: ${p.quantity}`} />
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            </Grid>
            <Grid item xs={4}>
                <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h6">Carrito</Typography>
                    <List sx={{ flexGrow: 1, overflow: 'auto' }}>
                        {cart.map((item, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={item.name} secondary={`1 x $${item.sale_price}`} />
                                <Typography>${item.total}</Typography>
                            </ListItem>
                        ))}
                    </List>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h4" align="right">Total: ${total}</Typography>
                    <Button variant="contained" size="large" fullWidth sx={{ mt: 2 }} onClick={handleCheckout}>
                        COBRAR
                    </Button>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default POS;
